module.exports = __webpack_public_path__ + "static/img/committeeSeal.48ba58d4.png";